import PageCommon from "./../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import Globals from "../../Globals.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../../Security.js";
import { ModalConfirm, ModalAlert } from "../../su/Modals.js";

export default class PageList extends PageCommon {
	constructor() {
		super();
	}
	init($data) {
		super.init($data);
		this.data = $data;
		this.showPreloader(false);
		//
		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.tableSUid, SecurityAcl.ACL_CREATE))) {
			$(".jsBtnNew").on("click", this.onAdd.bind(this))
		} else {
			$(".jsBtnNew").remove();
		}

		// 
		this.initList();

		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
	}

	initListButton(ev) {
		// eventType, gridWrp, dataIndex, dataRow, mcCol
		// alert(this.data.tableSUid + ev.dataRow.Value);
		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(ev.dataRow.SUid, SecurityAcl.ACL_DELETE))) {
			$(".btnDelete", ev.mcCol).on("click", this.onDelete.bind(this, ev.dataIndex));
		} else {
			$(".btnDelete", ev.mcCol).remove();
		}
		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(ev.dataRow.SUid, SecurityAcl.ACL_READ))) {
			$(".btnView", ev.mcCol).on("click", this.onNavigate.bind(this, ev.dataIndex));
		} else {
			$(".btnView", ev.mcCol).remove();
		}
	}

	onDelete(dataIndex) {
		let modal = new ModalConfirm($("#template-modalConfirm"));
		modal.create(
			{
				title: "DELETE CONFIRM",
				body: "Are you sure you want to permanently remove this item? You can't undo this action.",
				yes: "YES",
				no: "NO",
				danger:true // viene il pulsante rosso, altrimenti blue
			}, this.onConfirmDelete.bind(this, dataIndex));
		modal.init();
	}

	onConfirmDelete(dataIndex, bConfirm) {
		if (bConfirm) {
			// this.theGrid.deleteByDataIndex(dataIndex)
			this.showPreloader(true);
			let rq = {
				Value: this.theGrid.data[dataIndex].Uid
			}
			thatServiceManeger.standardCall(this.data.serviceDeleteRoute + this.data.tableUid, rq, this.onDeleteServiceHandler.bind(this, dataIndex));
		}
	}

	onDeleteServiceHandler(dataIndex, rs) { 
		this.showPreloader(false);
		//
		if (rs.Success) {
			this.theGrid.deleteByDataIndex(dataIndex);
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "SUCCESS",
					body: "Deletion successful!",
					close: "CLOSE",
					error: false
				});
			modal.init();
		} else {
			let error = null;
			if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length >= 0) {
				error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
				if (rs.Errors[0].RefsUid.length > 0) {
					error = error.replace("{0}", rs.Errors[0].RefsUid);
				}
			}
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP." + rs.StatusCode];
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP.DEFAULT"];
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "AN ERROR OCCURRED",
					body: error,
					close: "CLOSE",
					error: true
				});
			modal.init();
		}
		//this.showPreloader(false);
	}

	onNavigate(dataIndex) {
		document.location.href = TheApp.Env.BaseUrlNls + "lookup/" + this.data.tableUid.toLowerCase() + "/detail/" + Base64.toBase64(this.theGrid.data[dataIndex].Value,true) + "?__pi=" + this.data.page.PageId;
	}

	onAdd() {
		document.location.href = TheApp.Env.BaseUrlNls + "lookup/" + this.data.tableUid.toLowerCase() + "/detail" + "?__pi=" + this.data.page.PageId;
	}

	initList() {
		// console.log("PageList::initShieldCommonComponents to override");
	}

	getAvailableHeight() {
		let availableHeight = 0;
		let i = 0;
		i += jQuery("header").first().outerHeight(); // header nav gialla

		i += (jQuery(".app-container").length > 0) ? parseInt(jQuery(".app-container").first().css("padding-top")) : 0; // app-container
		i += (jQuery(".app-container").length > 0) ? parseInt(jQuery(".app-container").first().css("margin-top")) : 0; // app-container

		i += (jQuery(".breadcrumb").length > 0) ? jQuery(".breadcrumb").first().outerHeight(true) : 0; // breadcrumb

		i += (jQuery(".header-info").length > 0) ? jQuery(".header-info").first().outerHeight(true) : 0; // header-info

		i += (jQuery(".content").length > 0) ? parseInt(jQuery(".content").first().css("padding-top")) : 0 // container padding-top
		i += (jQuery(".content").length > 0) ? parseInt(jQuery(".content").first().css("margin-top")) : 0 // container margin-top

		i += (jQuery(".jsBtnNew").length > 0) ? jQuery(".jsBtnNew").first().parent().outerHeight(true) : 0; // pulsante add new
		i += (jQuery(".search-box").length > 0) ? jQuery(".search-box").first().outerHeight(true) : 0; // search-box
		if (jQuery(".search-box").length > 0) {
			if (jQuery(".search-box").first().parent().prev().length > 0) {
				if (!jQuery(".side-bar").length > 0) {
					i += jQuery(".search-box").first().parent().prev().outerHeight(true); // search-box previous el
				}
			}
			if (jQuery(".search-box").first().prev().length > 0) {
				i += jQuery(".search-box").first().prev().outerHeight(true); // search-box previous el
			}
			i += parseInt(jQuery(".search-box").first().parent().css("margin-top")); // search-box parent mt
		}

		i += (jQuery(".jsBtnSearchCalendar").length > 0) ? jQuery(".jsBtnSearchCalendar").last().parent().outerHeight(true) : 0; // btn search-calendar parent

		i += 75; // pager
		availableHeight = jQuery(window).height() - i;
		console.log(availableHeight);
		return availableHeight;
	}
} 